import React from 'react';

const Text = ({text, component: Component = 'span'}) => (
  <Component
    dangerouslySetInnerHTML={{__html: text.replaceAll('\n', '<br/>')}}
  />
);

export default Text;
